<i18n>
{
    "de": {
        "Not logged in": "Nicht angemeldet",
        "Profile": "Profil",
        "Manage account::Title": "Passwort ändern, 2-Faktor-Authentifizierung einstellen, ...",
        "Manage account": "Konto verwalten",
        "Logout": "Abmelden"
    },
    "en": {
        "Not logged in": "Not logged in",
        "Profile": "Profile",
        "Manage account::Title": "Change password, set two factor authentication, ...",
        "Manage account": "Manage account",
        "Logout": "Logout"
    }
}
</i18n>

<template>
    <div class="w3-container" style="position: relative;">
        <div v-if="user === null" class="profile-button-container">
            <p>{{ $t('Not logged in') }}.</p>
        </div>
        <div v-if="user !== null" class="profile-button-container">
            <a id="showProfileButton" class="w3-small w3-text-white" @click="showProfileButton_click($event)" :title="`${$t('Profile')}: ${user.name}`">
                <img src="../assets/img/profile-button-32.png" :alt="user.name"><br>
                {{ user.name }}
            </a>
            <div id="profile-box"
                    :class="[{'w3-show': showProfile}]"
                    @click="profileBox_click($event)">
                <h3 class="theme-color-primary-d5">{{user.employer.name}}</h3>
                <p>
                    {{user.employer.address}}<br>
                    {{user.employer.zip}} {{user.employer.city}}<br>
                    {{user.employer.state}}<br><br>
                    {{user.phone}}<br>
                    {{user.email}}
                </p>
                <router-link class="w3-button theme-primary theme-primary-l1-hover" to="/account" 
                        @click="showProfile = false" :title="$t('Manage account::Title')">
                    {{ $t('Manage account') }}
                </router-link>&nbsp;
                <a class="w3-button theme-primary w3-hover-red" href="javascript:void(0)" @click="doLogout()">{{ $t('Logout') }}</a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.profile-button-container {
    padding-top: 4px;
    text-align: center;
    height: 60px;
}

#profile-box {
    min-width: 350px;
    padding: 10px;
    position: absolute;
    right: 25px;
    top: 30px;
    text-align: right;
    display: none;
    background: #fff;
    color: #000;
    border-right: 8px solid #f1c753;
    border-radius: 2px;
    box-shadow: 1px 1px 4px #333;
}

#profile-box h3 {
    font-size: 1.1em;
    font-weight: bold;
}

#showProfileButton {
    cursor: pointer;
}
</style>

<script>
import store from '@/store'
import EventBus from '@/util/EventBus'
import Api from 'api-client'

export default {
    name: 'profile-button',
    data () {
        return {
            showProfile: false
        }
    },

    computed: {
        user: () => { return store.state.currentUser }
    },

    created () {
        window.addEventListener('click', this.window_click)
    },

    destroyed () {
        window.removeEventListener('click', this.window_click)
    },

    methods: {
        window_click () {
            this.showProfile = false
        },

        profileBox_click (event) {
            if (['A', 'BUTTON'].indexOf(event.target.tagName) === -1) {
                event.stopPropagation()
            }
        },

        showProfileButton_click (event) {
            this.showProfile = !this.showProfile
            event.stopPropagation()
        },

        doLogout () {
            var self = this

            Api.logout()
                .then(() => {
                    EventBus.$emit('logout')
                    store.commit('setCurrentUser', null)
                    store.commit('xAuthToken', '')
                    self.$router.push('/login')
                })
                .catch(() => {
                    window.toast({
                        text: self.$i18n.t('errors.apiCommunication'),
                        color: 'red'
                    })
                })
        }
    }
}
</script>
